export default "__VITE_ASSET__944bd943__"